import { useState, useEffect } from 'react'
import PubSub from 'pubsub-js'
import { gql } from '@apollo/client'
import { Button, Alert, Modal, ModalHeader, ModalBody, ModalFooter, Form, Row, Col, Label, Input } from 'reactstrap'
import { SAVE_USER_ATTRIBUTE_MUTATION } from '../../graphql'
import { handleGraphQLErrors } from '../../utils.js'
import Spinner from '../Spinner/Spinner'

const SAVE_USER_ATTRIBUTE = gql(SAVE_USER_ATTRIBUTE_MUTATION)

export default function UserAttributeModal({ userId }) {
  console.log('UserAttributesModal rendered')

  const initialValues = {
    userValue: ''
  }
  const [inputs, setInputs] = useState(initialValues)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [modal, setModal] = useState(false)
  const [spinner, setSpinner] = useState(false)
  const [userAttribute, setUserAttribute] = useState({ name: '' })
  const toggle = () => setModal(!modal)

  useEffect(() => {
    function handleOpenModalEvent(msg, data) {
      console.log(`EVENT RECEIVED (UserAttributeModal): ${msg}`, data)
      setUserAttribute(data)
      setInputs({ userValue: data.value })
      toggle()
    }
    const token = PubSub.subscribe('OPEN USER ATTRIBUTE MODAL', handleOpenModalEvent)
    return function cleanup() {
      PubSub.unsubscribe(token)
    }
  })

  function handleUserValueChange(e) {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  }

  async function saveButtonClicked(e) {
    console.log('UserAttributeModal: saveButtonCLicked', userAttribute, inputs)

    setSpinner(true)
    try {
      const { data, errors } = await window.apolloClient.mutate({ mutation: SAVE_USER_ATTRIBUTE, variables: { userId: userId, attributeName: userAttribute.name, attributeValue: inputs.userValue } })
      console.log(data)
      if (errors) {
        setGraphQLErrors(errors)
      } else {
        const newAttribute = JSON.parse(JSON.stringify(userAttribute))
        newAttribute.value = inputs.userValue
        userAttribute.updateRow(newAttribute)
        toggle()
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    } finally {
      setSpinner(false)
    }
  }

  function cancelClicked() {
    setInputs({ userValue: ''})
    setGraphQLErrors([])
    toggle()
  }


  let saveErrorAlert = ''
  if (spinner) {
    saveErrorAlert = <Spinner />
  }
  if (graphQLErrors.length > 0) {
    saveErrorAlert = <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop={'static'} >
      <ModalHeader>{userAttribute.name}</ModalHeader>
      <ModalBody>
        <Form>
          {saveErrorAlert}
          <Row>
            <Col>
              <Label for="attribute-value" style={{ float: 'left'}}>User Value</Label>
              <Input name="userValue" id="userValue" value={inputs.userValue} onChange={handleUserValueChange} />
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={(e) => saveButtonClicked(e)}>Save</Button>{' '}
        <Button color="secondary" onClick={cancelClicked}>Cancel</Button>
      </ModalFooter>
    </Modal>
  )
}
